import { cn } from "@/lib/utils";

/**
 * Standalone iOS-style switch — the right-hand slot for boolean rows
 * in `SettingsRow`. Kept presentational so the parent can wire its
 * own async permission-prompt flow on `onChange`.
 */
export function Switch({
  id,
  checked,
  onChange,
  disabled,
  "aria-label": ariaLabel,
}: {
  /** Lets a `<label for>` name the switch (a `<button>` is labelable). */
  id?: string;
  "aria-label"?: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-label={ariaLabel}
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        "relative h-6 w-10 shrink-0 rounded-full transition-colors",
        checked ? "bg-wx-primary" : "bg-wx-bg-elevated-2",
        disabled && "cursor-not-allowed opacity-60",
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          "absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform",
          checked && "translate-x-4",
        )}
      />
    </button>
  );
}
